import { ThirdPartyEvaluationFormItem } from './thirdparty-evaluation-form-item';
import { ThirdPartyEvaluationFormItemRecordColumnPossibleAnswer } from './thirdparty-evaluation-form-item-record-column-possible-answer';

export class ThirdPartyEvaluationFormItemRecordColumn {
    id: number = 0;
    title: string = '';
    columnOrder: number;
    columnTypeId: number;
    recordTypeId?: number;
    recordTypeAutocompleteReference?: number;
    recordField?: string = null;
    formula?: string = null;
    useVerticalTotalizer: boolean = false;
    possibleAnswers?: ThirdPartyEvaluationFormItemRecordColumnPossibleAnswer[]
                    = [new ThirdPartyEvaluationFormItemRecordColumnPossibleAnswer()];

    constructor() {
    }
}
